module.exports = __webpack_public_path__ + "img/userIcon2.627ad736.png";